/**
 * KÖRVONAL — lift the delivery-method picker into the cart's left column.
 *
 * PickupBird (Digiloop) mounts its Házhozszállítás / Csomagpont selector as an
 * app block in its own template section, which Shopify stacks BELOW the cart
 * grid. On desktop that left the choice stranded under ~600px of empty space
 * while the Pénztár button sat far above it, so the picker read as an appendix
 * to the page rather than a step in the checkout.
 *
 * WHY A NODE MOVE AND NOT innerHTML
 *   The picker is a mounted app with its own listeners and internal state. A
 *   move with appendChild relocates the same element, so handlers and state
 *   survive; assigning innerHTML anywhere in its ancestry would destroy and
 *   recreate the nodes and silently unbind everything — which is exactly how
 *   the cart's adószám field lost its listeners once before.
 *
 * WHY IT MATTERS THAT THIS IS THE PICKUP WIDGET
 *   The locker + COD flow is a two-app chain keyed on the shipping rate name.
 *   If this element stops working, pickup-point orders stop being placeable, so
 *   the move is deliberately conservative: it relocates the block, dispatches a
 *   resize so anything that measured its old container re-measures, and does
 *   nothing at all if the layout is not the one it expects.
 *
 * TO REVERT: delete the script tag from sections/main-cart.liquid. The block
 * goes back to where Shopify puts it, and nothing else changes.
 */
(function () {
  'use strict';

  function lift() {
    // Shopify puts the app's name in the block's ID and its inner wrapper's
    // class, but never both on one element — matching only `.shopify-app-block`
    // with a class filter finds nothing at all.
    var hit = document.querySelector('[id*="pickupbird"], [class*="pickupbird"]');
    var block = hit && (hit.closest('.shopify-app-block') || hit);
    if (!block || block.dataset.kvLifted) return !!block;

    var section = block.closest('.shopify-section');
    var cart = document.querySelector('.cart-section');
    var left = cart && cart.children[0];
    // Only the two-column desktop layout has the dead space this fixes, and
    // only that layout has somewhere to put it.
    if (!section || !left || getComputedStyle(cart).display !== 'grid') return true;

    block.dataset.kvLifted = '1';
    left.appendChild(block);

    // The empty shell the block came from would otherwise leave a gap.
    if (section.textContent.trim() === '') section.style.display = 'none';

    // Anything that sized itself against the old container gets a chance to
    // re-measure — the map in particular.
    window.dispatchEvent(new Event('resize'));
    return true;
  }

  // The app mounts asynchronously, so poll briefly rather than racing it. Give
  // up after ~10s: a picker left where Shopify put it is a cosmetic problem, a
  // script retrying forever is a real one.
  var tries = 0;
  var timer = setInterval(function () {
    if (lift() || ++tries > 40) clearInterval(timer);
  }, 250);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lift);
  } else {
    lift();
  }
})();
